export const widths = {
  wide: '1260px',
  mediumHeaderSectionMax: '475px',
}
